import { Program } from '~shared/api/categories/types'
import { TPopProgram } from '~shared/api/programs-popular/types'

type PartialProgram = {
  slug: string | null
  category?: {
    slug: string | null
    slugSingular?: string | null
  } | null
  faculty?: {
    slug: string | null
  } | null
  diplomas?: Array<{ slug: string | null }> | null
}

export const programLink = (program: Program | PartialProgram | TPopProgram) => {
  const categorySlug = program?.category?.slug
  const allowedCategories = [
    'bakalavriat',
    'magistratura',
    'college',
    'mba',
    'gruppa-vyhodnogo-dnya'
  ].includes(categorySlug ?? '')

  if (allowedCategories) {
    return `/programs/${categorySlug}/${program?.faculty?.slug}/${program.slug}`
  }

  if (categorySlug === 'kurs' || categorySlug === 'kursy') {
    const isQualification = program?.diplomas?.some(
      (d: any) => d.slug === 'udostoverenie-o-povyshenii-kvalifikaczii'
    )
    const typeSlug = isQualification
      ? 'povyshenie-kvalifikacii'
      : 'perepodgotovka'
    return `/programs/kursy/${program?.faculty?.slug}/${typeSlug}/${program.slug}`
  }
  // у остальных категорий нет страницы программы — ведём в каталог
  return '/programmy'
}
